export { default } from './FileArtworkImage';
